import { render, staticRenderFns } from "./InsuaranceCard.vue?vue&type=template&id=6a1fd59e&"
import script from "./InsuaranceCard.vue?vue&type=script&lang=ts&"
export * from "./InsuaranceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports